var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "r-dashboard u-col" },
    [
      _c("item-header", { attrs: { loading: _vm.loading } }),
      _vm._v(" "),
      _c("div", { staticClass: "container u-flex" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.loading,
                expression: "!loading"
              }
            ],
            staticClass: "grid"
          },
          [
            _c(
              "router-link",
              { staticClass: "tile create u-fl", attrs: { to: "/new" } },
              [_c("icon-plus", { staticClass: "u-center" })],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.templates, function(template) {
              return _c(
                "router-link",
                {
                  key: template.id,
                  staticClass: "tile template u-tile u-fl",
                  attrs: { to: "/" + template.id }
                },
                [
                  _c("img", { attrs: { src: template.image } }),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(template.name))])
                ]
              )
            })
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }